import { render } from "./ImagesHumanBis.vue?vue&type=template&id=75ee1b7d"
import script from "./ImagesHumanBis.vue?vue&type=script&lang=js"
export * from "./ImagesHumanBis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__